import { useState } from 'react';

import { MultiAccurate } from '@lcsc-design/utils/decimal';

import Image from '@/components/Image';
import ImagePreview from '@/components/mobile/ImagePreview';
import { lcBookProvider } from '@/constants';
import useProductStore from '@/store/product';

export default function ProductTop({ data }) {
  const productRecord = data?.productRecord || {};

  const { productAsyncData } = useProductStore();

  const ParamItem = ({ label, value }) => {
    return String(value) ? (
      <div className="flex mt-[16px] text-[12px]">
        <dt className="text-[#7a8599] shrink-0">{label}</dt>
        <dd className="ml-[10px] text-[#334463] break-all" title={value}>
          {value}
        </dd>
      </div>
    ) : (
      <></>
    );
  };

  const LocalContext = () => {
    return (
      <dl>
        <ParamItem label="描述" value={productRecord?.remark} />
        <ParamItem label="品牌名称" value={productRecord?.brandName || productRecord?.productGradePlateName} />
        <ParamItem label="商品名称" value={productRecord?.productName} />
        <ParamItem label="商品编号" value={productRecord?.productCode || productRecord?.productCodeProvider} />
        <ParamItem label="商品封装" value={productRecord?.standard || productRecord?.encapsulationModel} />
        <ParamItem label="包装方式" value={productRecord?.productArrange || productRecord?.packaging} />
        {productRecord?.productWeight && (
          <ParamItem label="商品毛重" value={MultiAccurate(productRecord?.productWeight || 0, 1000) + '克(g)'} />
        )}
        {productRecord?.designReferenceVOS?.length &&
          productRecord?.designReferenceVOS?.map((designReferenceVO, idx) => {
            return (
              <div className="flex mt-[16px] text-[12px]" key={idx}>
                <dt className="text-[#7a8599]">{designReferenceVO?.designReferenceName}</dt>
                <dd className="ml-[10px] text-[#334463]" title={designReferenceVO.designReferenceTitle}>
                  {designReferenceVO?.designReferenceTitle}
                </dd>
              </div>
            );
          })}
        <ParamItem
          label="库存"
          value={`${stockNumber}（广东仓${productAsyncData.gdWarehouseStockNumber || 0} | 江苏仓${productAsyncData.jsWarehouseStockNumber || 0}）`}
        />
      </dl>
    );
  };

  const OverseaContext = () => {
    return (
      <dl>
        <ParamItem label="厂家型号" value={productRecord?.productCodeManufacturer} />
        <ParamItem label="商品品牌" value={productRecord?.productGradePlateName} />
        {!lcBookProvider.includes(productRecord?.provider) && (
          <>
            <ParamItem label="供应商" value={productRecord?.providerAlias || productRecord?.provider} />
            <ParamItem label="供应商编号" value={productRecord?.productCodeProvider} />
          </>
        )}
        <ParamItem label="产地" value={productRecord?.placeOfOrigin} />
        <ParamItem label="地区" value={productRecord?.productRegion} />
        <ParamItem label="批次" value={productRecord?.batchNumber} />
        <ParamItem label="封装" value={productRecord?.selfStandard} />
        <ParamItem label="包装方式" value={productRecord?.packagingList?.join(' / ')} />
        <ParamItem label="描述" value={productRecord?.selfProductIntro} />
      </dl>
    );
  };

  const stockNumber = data?.totalStockNumber || 0;

  const imageList = productRecord?.luceneBreviaryImageUrls?.split('<$>') || [];

  const [imagePreviewVisible, setImagePreviewVisible] = useState(false);

  return (
    <section className="flex justify-between p-[10px]">
      <div>
        <h1 className="leading-[21px]">{productRecord?.model || productRecord?.productModel}</h1>
        {productRecord?.isOversea ? <OverseaContext /> : <LocalContext />}
      </div>
      <div className="shrink-0 ml-[24px]">
        <Image
          src={imageList[0] || 'https://static.szlcsc.com/ecp/assets/app/product-list/nothing.png'}
          alt={`${productRecord?.productModel}实物图`}
          className="rounded-[8px]"
          width={80}
          height={80}
          fallback="https://static.szlcsc.com/ecp/assets/app/product-list/nothing.png"
          onClick={() => setImagePreviewVisible(true)}
        ></Image>
      </div>
      <ImagePreview
        images={imageList}
        visible={imagePreviewVisible}
        onClose={() => setImagePreviewVisible(false)}
      ></ImagePreview>
    </section>
  );
}
